$('.add-cart').on('click', function () {
   setTimeout(function(){
  $('#products-recommended-upsells').addClass("active");
     }, 1000);
});

$('.cls_product_upsells, .upsell_hover, .nobtn').on('click', function () {
  $('#products-recommended-upsells').removeClass("active");
  $("#added-box-wrapper").removeClass('show_bag'); 
  $(".blk_tras").removeClass('active');
   $("body").removeClass('no_scroll');   
});

$('.products-upsell-cardadd .add-cart').on('click', function () {
  setTimeout(function(){
  $('#products-recommended-upsells').removeClass("active");
     }, 1000);
    setTimeout(function(){
    $("#added-box-wrapper").addClass('show_bag'); 
      $(".blk_tras").addClass('active');
       $("body").addClass('no_scroll'); 
    }, 1200);
});

$(document).on("click", ".bag_link", function() { 	  
   $("#added-box-wrapper").addClass('show_bag'); 
      $(".blk_tras").addClass('active');
       $("body").addClass('no_scroll');   
    
 });

$(document).on("click", ".blk_tras, .close_box", function() { 	  
   $("#added-box-wrapper").removeClass('show_bag'); 
      $(".blk_tras").removeClass('active');
       $("body").removeClass('no_scroll');   
    
 });
$(document).on("click", ".viewcart_btn", function() { 	  
      $("#added-box-wrapper").addClass('show_bag'); 
      $(".blk_tras").addClass('active');
      $("body").addClass('no_scroll');  
    
 });

